/**
 * SchemaCreatePage - Page wrapper for schema creation wizard
 *
 * Provides a container for the multi-step schema creation wizard.
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import { SchemaCreationWizard } from '@/features/schemas/components/SchemaCreationWizard';

/**
 * SchemaCreatePage Component
 *
 * Simple wrapper page that renders the schema creation wizard
 * in a max-width container with consistent spacing.
 *
 * Uses location.key to force wizard remounting on navigation,
 * ensuring the wizard state is properly reset each time the
 * user navigates to /schemas/new.
 *
 * @example
 * ```tsx
 * <Route path="/schemas/new" element={<SchemaCreatePage />} />
 * ```
 */
export const SchemaCreatePage: React.FC = () => {
  const location = useLocation();

  return (
    <div className="container mx-auto max-w-5xl py-8">
      {/* key forces remount when navigating to this route */}
      <SchemaCreationWizard key={location.key} />
    </div>
  );
};
